import React, { useEffect } from "react";
import "./index.scss";
import { setResponsiveImage } from "../../helpers";

interface HeroCircuitProps {
  tourName?: string;
  mobileImage?: string;
  tabletImage?: string;
  desktopImage?: string;
}

const HeroCircuit = ({
  tourName = "Tour name here",
  mobileImage,
  tabletImage,
  desktopImage
}: HeroCircuitProps) => {
  useEffect(() => {
    setResponsiveImage({
      mobileImage,
      tabletImage,
      desktopImage,
      elClassName: "hero-circuit"
    });
    HeroCircuitInit();
  });

  return (
    <div className="hero-circuit">
      <div className="container">
        <h1 className="hero-circuit__title">
          <span>Welcome to</span>
          <span className="hero-circuit__name">{tourName}</span>
        </h1>
      </div>
      <a className="btn--chervon-down" id="btn-hero--chevron" />
    </div>
  );
};

export const HeroCircuitInit = () => {
  const btn: HTMLElement | null = document.getElementById("btn-hero--chevron");
  const banner: HTMLElement | null = document.querySelector(".hero-circuit");
  if (btn !== null && banner !== null) {
    btn.addEventListener("click", function() {
      scrollTo(0, banner.offsetHeight);
    });
  }
};

export default HeroCircuit;
